"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");require("core-js/modules/es6.number.constructor");









































































var _user = require("@/utils/user"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = { name: 'Intention', props: { apply: { type: Object, default: function _default() {return { id: '', applyCode: '', standardSlot: '' };} }, value: Number }, data: function data() {return { handleShow: false, tableData: [], // 列表数据
      bedIds: [], robotId: '', searchData: { ward: '', bedspace: '', page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, // 表格列
      tableColumns: [{ prop: 'ward', label: '病房号', isShow: true }, { prop: 'bedspace', label: '床位号', isShow: true }] };}, watch: { value: function value(oldV, newV) {// 监听父组件的变化
      this.bedIds = oldV;} }, mounted: function mounted() {// const self = this
    // self.init()
  }, methods: { init: function init(robotId) {var self = this;self.robotId = robotId;self.getData('/api/temi/medical/bed/robot/noBand/' + robotId, self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, resetFun: function resetFun() {// 重置
      this.searchData.ward = '';this.searchData.bedspace = '';this.init(this.robotId);}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init(this.robotId);}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init(this.robotId);}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init(this.robotId);},
    handleClose: function handleClose() {
      this.handleShow = false;
    },
    handleCheckRow: function handleCheckRow(row) {
      var self = this;
      // self.value = row.id
      self.apply.id = row.id;
      self.apply.name = row.name;
      self.apply.merchant = row.merchant;
      self.apply.voicePlatform = row.voicePlatform;
      // this.$emit('getCheckEvent', event)
    },
    sendMsgToParent: function sendMsgToParent() {
      var self = this;
      self.$emit('sendMsgToParent', self.bedIds);
      self.handleShow = false;
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.$refs.addForm.resetFields();
      this.cleanData();
      this.newadd = false;
    },
    closeDiglog: function closeDiglog() {
      this.handleShow = false;
    } } };exports.default = _default2;